<template>
  <div class="d-flex flex-wrap">
    <div v-for="(item, i) in arr" :key="i">
      <v-hover v-slot="{ hover }">
        <v-card class="ma-1" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" width="240" min-height="240">
          <v-img :src="item.imgUrl" contain></v-img>
          <v-card-actions>
            <v-btn color="red" icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <span>{{ item.heartCount }} </span>
          </v-card-actions>
        </v-card>
      </v-hover>
    </div>
  </div>
</template>

<script>
const arr = [
  {
    id: 1,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (19).jpg",
    heartCount: 12,
  },
  {
    id: 2,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (18).jpg",
    heartCount: 32,
  },
  {
    id: 3,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (16).jpg",
    heartCount: 9,
  },
  {
    id: 4,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (15).jpg",
    heartCount: 11,
  },
  {
    id: 5,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (12).jpg",
    heartCount: 12,
  },
  {
    id: 6,
    imgUrl: "/cdn/v1/assets/accessories/Rend_0000 (9).jpg",
    heartCount: 24,
  },
  {
    id: 7,
    heartCount: 14,
    imgUrl: "/cdn/v1/assets/accessories/prop046-unicorn-hat-3d-model-max-obj-fbx.jpg",
  },
  {
    id: 8,
    imgUrl: "/cdn/v1/assets/accessories/pack006-cartoon-hat-pack-2-3d-model-2377d775af.jpg",
    heartCount: 17,
  },
  {
    id: 9,
    imgUrl: "/cdn/v1/assets/accessories/pack006-cartoon-hat-pack-2-3d-model-05d49b813e.jpg",
    heartCount: 17,
  },
  {
    id: 10,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-e0ac07e2b6.jpg",
    heartCount: 17,
  },
  {
    id: 11,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-e1f48b146f.jpg",
    heartCount: 14,
  },
  {
    id: 12,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-d3eb19a381.jpg",
    heartCount: 23,
  },
  {
    id: 13,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-c09b1aa367.jpg",
    heartCount: 14,
  },
  {
    id: 14,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-27304d157f.jpg",
    heartCount: 18,
  },
  {
    id: 15,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-96e58a2ec7.jpg",
    heartCount: 24,
  },
  {
    id: 16,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-46f2072a6b.jpg",
    heartCount: 9,
  },
  {
    id: 17,
    imgUrl: "/cdn/v1/assets/accessories/pack003-cartoon-hat-pack1-3d-model-1ea7c91e85.jpg",
    heartCount: 4,
  },
];
export default {
  data() {
    return {
      arr,
    };
  },
};
</script>

<style></style>
